var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"report-notify-container dx-overlay dx-overlay-wrapper dx-toast-wrapper"},[_c('div',{class:`report-notify-notification${_vm.alert ? '-alert' : ''}${
        _vm.warning ? '-warning' : ''
      }`},[(!_vm.alert && !_vm.warning)?_c('div',{staticClass:"spinner-notify-container"},[_c('div',{staticClass:"spinner-notify"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"notify-text"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }